import React from "react";
import { Form, DatePicker, TimePicker, Popover, Icon, Button } from "antd";
import moment from "moment";

moment.locale("ru");

const DeliveryDateTime = ({
  form,
  handleShowSchedule,
  disabled,
  updateRouteDuration
}) => {
  const { getFieldDecorator, getFieldValue } = form;
  const timeFromNow = getFieldValue("arrivalDatetime");
  const routes = getFieldValue("routes");
  const routesLen = (routes && routes.length) || 0;
  const popover = (
    <div className="popover-content">
      <p>
        Количество минут плановой остановки (ожидания) в промежуточном пункте,
        включенных в цену перевозки.
      </p>
    </div>
  );
  const extra1 =
    disabled &&
    getFieldValue("routeDuration0", {
      rules: [
        {
          required: true,
          message: "Поле, обязательное для заполнения"
        }
      ]
    })
      ? " (Длительность посадки: " +
        moment(getFieldValue("routeDuration0")).hours() * 60 +
        moment(getFieldValue("routeDuration0")).minutes() +
        " мин)"
      : "";

  return (
    <>
      <div className="offer-card__item order-card__item">
        <span className="label">Дата и время подачи:</span>
        <Form.Item
          extra={timeFromNow && moment(timeFromNow).fromNow() + extra1}
        >
          {getFieldDecorator("arrivalDatetime", {
            rules: [
              {
                required: true,
                message: "Поле, обязательное для заполнения"
              }
            ],

          })(
            <DatePicker
              style={{ width: 224 }}
              format="DD.MM.YYYY"
              placeholder="ДД.ММ.ГГГГ"
              disabledDate={currentDate => moment() > currentDate}
              disabled={disabled}
            />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator("arrivalDatetime", {
            rules: [
              {
                required: true,
                message: "Поле, обязательное для заполнения"
              }
            ]
          })(
            <TimePicker
              style={{ width: 128 }}
              placeholder="Время"
              format="HH:mm"
              disabled={disabled}
            />
          )}
        </Form.Item>
        {!disabled ? (
          <span className="extra-label additional-input">
            <span className="show-map">
              <Popover
                overlayClassName="order-popover"
                placement="topLeft"
                content={popover}
                trigger="click"
              >
                <Icon type="question-circle" />
              </Popover>
            </span>
          </span>
        ) : (
          <span className="extra-label">
            <span className="show-map">
              <Button
                type="primary"
                ghost
                onClick={handleShowSchedule}
                disabled={routesLen < 1}
              >
                График движения
              </Button>
            </span>
          </span>
        )}
      </div>
      {!disabled && (
        <div className="offer-card__item">
          <span className="offer-card__non-label additional-input">
            <Form.Item
              className="additional-input__item"
              extra={
                getFieldValue("routeDuration0") &&
                moment(getFieldValue("routeDuration0")).hours() * 60 +
                  moment(getFieldValue("routeDuration0")).minutes() +
                  " мин"
              }
            >
              {getFieldDecorator("routeDuration0", {
                rules: [
                  {
                    required: true,
                    message: "Поле, обязательное для заполнения"
                  }
                ],
                initialValue: moment('00-15', "HH-mm")
              })(
                <TimePicker
                  style={{ width: 128 }}
                  defaultOpenValue={moment("00:00", "HH:mm")}
                  placeholder="Время"
                  format="HH:mm"
                  onChange={val => updateRouteDuration(0, val)}
                  disabled={disabled}
                />
              )}
            </Form.Item>
            <span>
              Расчетное время посадки в пункте подачи (Т1), мин:&nbsp;
            </span>
          </span>
        </div>
      )}
    </>
  );
};

export default DeliveryDateTime;
